import _ from 'lodash';
import moment from 'moment';
import PropTypes from "prop-types";
import React from "react";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as documentActions from '../../actions/documentActions';
import * as previewOrderActions from '../../actions/mpOnlineActions';
import * as helper from "../common/order-helper";
import { ActionBar, ActionButton } from "../common/action-bar";
import { ClearableSearchBar } from '../common/searchBoxWithClear';
import * as modalMessages from '../modals/modalMessages';
import { filterItemsV2, isValidInteger } from "./../../common/utils/generalFunctions";
import { MessageType, ModalTypes, MessageLocation } from './../../common/utils/stringConstants';
import Table  from "./../../components/common/table";
import * as selectors from "./../../selectors";
import Modal from './../modals/modal';
import { PromptModal } from './../modals/prompt-modal';
import AddRemoveItemsModal from './add-remove-items-modal';
import { EditDraftOrderConfirmation } from './order-confirmation';
import EditDraftOrderRow from "./order-detail-row";
import { EditDraftOrderSummary } from './order-summary';
import { EditDraftOrderTotalRow } from './total-row';

let headers = [
  { header: "Qty", className: "setWidth60 table-cell-center", name: "quantity", disableSort: true },
  { header: "Item Number", className: "setWidth100", name: "itemNumber" },
  { header: "Description", className: "setWidth300", name: "description" },
  { header: "Unit", className: "setWidth60 table-cell-center", name: "unit" },
  { header: "Pack", className: "setWidth60 table-cell-center", name: "pack" },
  { header: "Price", className: "setWidth80 table-cell-center isCurrency", name: "price" },
  { header: "SubTotal", className: "setWidth80 table-cell-center isCurrency", name: "subTotal" },
  { header: "Line Note", className: "setWidth180", name: "lineNote" }
];

/* istanbul ignore next */
export class EditDraftOrder extends React.Component {
  static propTypes = {
    vendor: PropTypes.object,
    account: PropTypes.object,
    history: PropTypes.object,
    headerId: PropTypes.number,
    shoppingCartItems: PropTypes.array,
    documentActions: PropTypes.object,
    previewOrderActions: PropTypes.object,
    purchaseOrder: PropTypes.object,
    purchaseOrderUpdateResult: PropTypes.object,
    orderDetailPdf: PropTypes.string,
    orderGuideItems: PropTypes.array,
    selectedOrderGuide: PropTypes.object,
    selectedShipDate: PropTypes.string,
    selectedDeliveryDate: PropTypes.string,
    conceptAttributes: PropTypes.array,
    deliverDateVisible: PropTypes.bool,
    shipDateVisible: PropTypes.bool
  };

  constructor(props) {
    super(props);

    // Fresh start: only consume selected headerId from route state.
    const selectedHeaderId = this.props.history && this.props.history.location && this.props.history.location.state
      ? this.props.history.location.state.headerId
      : null;

    this.state = {
      isModalVisible: false,
      modalMessage: '',
      messageType: '',
      modalErrorType: '',
      canDelete: true,
      deletedItems: [],
      itemToRemove: {},
      filterText: "",
      shoppingCartItems: [],
      filteredShoppingCartItems: [],
      orderNumber: "",
      orderNote: "",
      canShowOrderConfirmation: false,
      orderWasSavedAsDraft: false,
      hasUnsavedChanges: false,
      selectedHeaderId,
      draftOrder: selectedHeaderId ? { headerId: selectedHeaderId, purchaseOrderHeader: {} } : null,
      showUnsavedChangesWarning: false,
      unsavedChangesNavigateTo: null,
      showApproveSubmitConfirmation: false,
      showCancelOrderConfirmation: false,
      showAddRemoveItemsModal: false,
      confirmationActionType: ''
    };
  }

  UNSAFE_componentWillMount() {
    if (helper.canSeeRequestedShipDate(this.props.conceptAttributes)) {
      const requestedShipDateHeader = { header: "Requested Ship Date", className: "setWidth100 table-cell-center", name: "shipDate" };
      if (headers.findIndex(x => x.header === "Requested Ship Date") === -1) {
        const deliveryIndex = headers.findIndex(x => x.header === "Requested Arrival Date");
        if (deliveryIndex > -1) {
          headers.splice(deliveryIndex, 0, requestedShipDateHeader);
        } else {
          headers[headers.length] = requestedShipDateHeader;
        }
      }
    } else {
      const requestedShipDateHeaderIndex = headers.findIndex(x => x.header === "Requested Ship Date");
      if (requestedShipDateHeaderIndex > -1) {
        headers.splice(requestedShipDateHeaderIndex, 1);
      }
    }

    if (helper.canSeeRequestedDeliveryDate(this.props.conceptAttributes)) {
      const requestedDeliveryDateHeader = { header: "Requested Arrival Date", className: "setWidth100 table-cell-center", name: "deliveryDate" };
      if (headers.findIndex(x => x.header === "Requested Arrival Date") === -1) {
        headers[headers.length] = requestedDeliveryDateHeader;
      }
    } else {
      const requestedDeliveryDateHeaderIndex = headers.findIndex(x => x.header === "Requested Arrival Date");
      if (requestedDeliveryDateHeaderIndex > -1) {
        headers.splice(requestedDeliveryDateHeaderIndex, 1);
      }
    }
  }

  componentDidMount() {
    const { selectedHeaderId } = this.state;

    if (selectedHeaderId) {
      this.props.previewOrderActions.readPurchaseOrder(selectedHeaderId);
    }

    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentPurchaseOrder = this.props.purchaseOrder;
    const nextPurchaseOrder = nextProps.purchaseOrder;

    if (currentPurchaseOrder !== nextPurchaseOrder && nextPurchaseOrder && Object.keys(nextPurchaseOrder).length > 0) {
      const purchaseOrderRoot = nextPurchaseOrder.PurchaseOrderMPO || nextPurchaseOrder.purchaseOrderMPO || nextPurchaseOrder;
      const purchaseOrderHeader = purchaseOrderRoot.PurchaseOrderHeader || purchaseOrderRoot.purchaseOrderHeader || {};
      const normalizedPurchaseOrderHeader = {
        ...purchaseOrderHeader,
        shipDate: purchaseOrderHeader.shipDate || purchaseOrderHeader.ShipDate,
        deliveryDate: purchaseOrderHeader.deliveryDate || purchaseOrderHeader.DeliveryDate,
        orderNote: purchaseOrderHeader.orderNote || purchaseOrderHeader.OrderNote,
        purchaseOrderNumber: purchaseOrderHeader.purchaseOrderNumber || purchaseOrderHeader.PurchaseOrderNumber
      };

      this.setState({
        draftOrder: {
          headerId: this.state.selectedHeaderId,
          purchaseOrderHeader: normalizedPurchaseOrderHeader
        },
        shoppingCartItems: this.getShoppingCartItemsFromDraftOrder(purchaseOrderRoot),
        filteredShoppingCartItems: this.getShoppingCartItemsFromDraftOrder(purchaseOrderRoot),
        orderNumber: normalizedPurchaseOrderHeader.purchaseOrderNumber || this.state.orderNumber,
        orderNote: normalizedPurchaseOrderHeader.orderNote || this.state.orderNote
      });
    }

    if (this.props.purchaseOrderUpdateResult !== nextProps.purchaseOrderUpdateResult && nextProps.purchaseOrderUpdateResult) {
      if (this.isUpdateResultSuccessful(nextProps.purchaseOrderUpdateResult)) {
        this.setState({
          canShowOrderConfirmation: true,
          hasUnsavedChanges: false,
          canDelete: false
        });
      } else {
        this.setState({
          isModalVisible: true,
          modalErrorType: ModalTypes.SystemError,
          messageType: MessageType.ERROR,
          modalMessage: this.getUpdateErrorMessage(nextProps.purchaseOrderUpdateResult),
          canShowOrderConfirmation: false,
          hasUnsavedChanges: true,
          canDelete: true
        });
      }
    }
  }

  isUpdateResultSuccessful = (updateResult) => {
    if (updateResult === true) {
      return true;
    }

    if (!updateResult || typeof updateResult !== 'object') {
      return false;
    }

    if (updateResult.responseStatus && updateResult.rowsAffected > 0) {
      return updateResult.responseStatus.errorCode === 'OK';
    }

    return false;
  };

  getUpdateErrorMessage = (updateResult) => {
    if (updateResult && updateResult.rowsAffected) {
      const errorCode = updateResult.rowsAffected;

        switch (errorCode) {
        case -5:
            return modalMessages.poSubmitPastCutOffErrorMessage;
        case -10:
            return modalMessages.dayNotInDeliveryRoute;
        case -15:
            return modalMessages.orderExceedsMaximumQuantity;
        default:
            return modalMessages.unidentifiedSystemError;
        }
    }

    return 'Unable to update draft order. Please try again.';
  };

  getShoppingCartItemsFromDraftOrder = (draftOrder) => {
    const purchaseOrderRoot = draftOrder?.PurchaseOrderMPO || draftOrder?.purchaseOrderMPO || draftOrder;
    const purchaseOrderDetails = purchaseOrderRoot?.PurchaseOrderDetails || purchaseOrderRoot?.purchaseOrderDetails;

    if (!draftOrder || !purchaseOrderDetails) {
      return [];
    }
    
    // Transform draft order details to shopping cart format
    return purchaseOrderDetails.map(detail => ({
      ...detail,
      order: detail.quantity ?? detail.Quantity ?? detail.order,
      masterRecordId: detail.masterRecordId ?? detail.MasterRecordId,
      vendorId: detail.vendorId ?? detail.VendorId,
      itemNumber: detail.itemNumber ?? detail.ItemNumber,
      description: detail.description ?? detail.Description,
      unit: detail.unit ?? detail.Unit,
      pack: detail.pack ?? detail.packSize ?? detail.Pack ?? detail.PackSize,
      packSize: detail.packSize ?? detail.pack ?? detail.PackSize ?? detail.Pack,
      price: detail.price ?? detail.Price,
      lineNote: detail.lineNote ?? detail.LineNote ?? "",
      maxPurchaseQuantity: detail.maxPurchaseQuantity ?? detail.MaxPurchaseQuantity,
      maxPurchaseQuantityStartDate: detail.maxPurchaseQuantityStartDate ?? detail.MaxPurchaseQuantityStartDate,
      maxPurchaseQuantityEndDate: detail.maxPurchaseQuantityEndDate ?? detail.MaxPurchaseQuantityEndDate
    }));
  };

  UNSAFE_componentWillUnmount() {
    if (this.props.headerId > 0) {
      this.props.previewOrderActions.clearShoppingCart();
    }
    this.props.previewOrderActions.createPurchaseOrderComplete(0);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  }

  handleBeforeUnload = (e) => {
    if (this.state.hasUnsavedChanges) {
      e.preventDefault();
      e.returnValue = '';
      return '';
    }
  };

  filter = (event) => {
    const { shoppingCartItems } = this.state;
    const inputValue = event.target.value.toLowerCase().trim();

    if (inputValue === "") {
      this.setState({
        filterText: event.target.value,
        filteredShoppingCartItems: shoppingCartItems
      });
      return;
    }

    const matchedItems = filterItemsV2(shoppingCartItems, inputValue);

    this.setState({
      filterText: event.target.value,
      filteredShoppingCartItems: matchedItems
    });
  };

  toggleModal = () => {
    this.setState({
      isModalVisible: !this.state.isModalVisible
    });
  };

  deleteItem = (item) => {
    let shouldDeleteItems = true;
    this.handleModalDisplay(item, shouldDeleteItems);
  };

  confirmDelete = () => {
    const { itemToRemove } = this.state;
    this.setState({ 
      deletedItems: this.state.deletedItems.concat(itemToRemove), 
      shouldDeleteItems: false,
      hasUnsavedChanges: true 
    });
    this.toggleModal();
  };

  updateLineNote = (event, item) => {
    const value = event.target.value;
    const updatedFilteredItems = _.cloneDeep(this.state.filteredShoppingCartItems);
    const updatedAllItems = _.cloneDeep(this.state.shoppingCartItems);

    const matchItem = x =>
      (x.masterRecordId && item.masterRecordId && x.masterRecordId === item.masterRecordId) ||
      (x.itemNumber && item.itemNumber && x.itemNumber === item.itemNumber);

    const filteredIndex = updatedFilteredItems.findIndex(matchItem);
    const allIndex = updatedAllItems.findIndex(matchItem);

    if (filteredIndex > -1) {
      updatedFilteredItems[filteredIndex].lineNote = value;
    }

    if (allIndex > -1) {
      updatedAllItems[allIndex].lineNote = value;
    }

    this.setState({
      shoppingCartItems: updatedAllItems,
      filteredShoppingCartItems: updatedFilteredItems,
      hasUnsavedChanges: true
    });
  };

  updateQuantity = (event, item) => {
    const value = event.target.value;

    if (!isValidInteger(value)) {
      return;
    }

    const updatedFilteredItems = _.cloneDeep(this.state.filteredShoppingCartItems);
    const updatedAllItems = _.cloneDeep(this.state.shoppingCartItems);

    const matchItem = x =>
      (x.masterRecordId && item.masterRecordId && x.masterRecordId === item.masterRecordId) ||
      (x.itemNumber && item.itemNumber && x.itemNumber === item.itemNumber);

    const filteredIndex = updatedFilteredItems.findIndex(matchItem);
    const allIndex = updatedAllItems.findIndex(matchItem);

    if (filteredIndex > -1) {
      updatedFilteredItems[filteredIndex].order = value;
    }

    if (allIndex > -1) {
      updatedAllItems[allIndex].order = value;
    }

    this.setState({
      shoppingCartItems: updatedAllItems,
      filteredShoppingCartItems: updatedFilteredItems,
      hasUnsavedChanges: true
    });
  };

  isDraftOrdersEnabled = () => {
    const { conceptAttributes } = this.props;

    if (!conceptAttributes || conceptAttributes.length === 0) {
      return false;
    }

    const attribute = conceptAttributes.find(x => x && x.name && x.name.toLowerCase() === 'enablempodraftorder');

    if (!attribute || typeof attribute.value === 'undefined' || attribute.value === null) {
      return false;
    }

    return attribute.value.toString().toLowerCase() === 'true';
  };

  onOrderSummaryChange = (event) => {
    const key = event.target.id;
    const value = event.target.value;
    this.setState({ [key]: value, hasUnsavedChanges: true });
  };

  onDeliveryDateChange = (date) => {
    if (!date || !moment(date).isValid()) {
      return;
    }

    const updatedDeliveryDate = moment(date).format('YYYY-MM-DD');
    const updateItemDeliveryDate = (items) => items.map(x => ({ ...x, deliveryDate: updatedDeliveryDate }));

    this.setState((prevState) => ({
      shoppingCartItems: updateItemDeliveryDate(prevState.shoppingCartItems),
      filteredShoppingCartItems: updateItemDeliveryDate(prevState.filteredShoppingCartItems),
      hasUnsavedChanges: true,
      draftOrder: {
        ...prevState.draftOrder,
        purchaseOrderHeader: {
          ...prevState.draftOrder?.purchaseOrderHeader,
          deliveryDate: updatedDeliveryDate
        }
      }
    }));
  };

  getDraftItemKey = (item) => {
    if (!item) {
      return '';
    }

    if (item.masterRecordId) {
      return `m-${item.masterRecordId}`;
    }

    if (item.itemNumber) {
      return `i-${item.itemNumber}`;
    }

    return '';
  };

  getSelectedOrderGuideHeaderId = () => {
    const selectedGuideId = this.props.selectedOrderGuide && this.props.selectedOrderGuide.orderGuideHeaderId
      ? this.props.selectedOrderGuide.orderGuideHeaderId
      : 0;

    if (selectedGuideId) {
      return selectedGuideId;
    }

    const sourceItem = this.state.shoppingCartItems && this.state.shoppingCartItems.length > 0
      ? this.state.shoppingCartItems[0]
      : null;

    return sourceItem
      ? (sourceItem.vendorGuideId || sourceItem.orderGuideHeaderId || sourceItem.OrderGuideHeaderId || 0)
      : 0;
  };

  getFilteredShoppingCartItems = (shoppingCartItems, filterText) => {
    if (!filterText || filterText.trim() === '') {
      return shoppingCartItems;
    }

    return filterItemsV2(shoppingCartItems, filterText.toLowerCase().trim());
  };

  openAddRemoveItemsModal = () => {
    const orderGuideHeaderId = this.getSelectedOrderGuideHeaderId();
    const deliveryDate = this.state.draftOrder?.purchaseOrderHeader?.deliveryDate || this.props.selectedDeliveryDate || undefined;
    const shipDate = this.state.draftOrder?.purchaseOrderHeader?.shipDate || this.props.selectedShipDate || undefined;

    if (orderGuideHeaderId) {
      this.props.previewOrderActions.getOrderGuideItems(
        orderGuideHeaderId,
        deliveryDate ? moment(deliveryDate) : undefined,
        shipDate ? moment(shipDate) : undefined
      );
    }

    this.setState({ showAddRemoveItemsModal: true });
  };

  closeAddRemoveItemsModal = () => {
    this.setState({ showAddRemoveItemsModal: false });
  };

  syncItemsFromOrderGuidePreview = (orderGuideItems) => {
    const draftHeaderId = this.state.draftOrder?.purchaseOrderHeader?.headerId
      || this.state.draftOrder?.purchaseOrderHeader?.HeaderId
      || this.state.draftOrder?.headerId
      || 0;

    const currentItemsByKey = {};
    (this.state.shoppingCartItems || []).forEach((item) => {
      const key = this.getDraftItemKey(item);
      if (key) {
        currentItemsByKey[key] = item;
      }
    });

    const updatedItems = (orderGuideItems || [])
      .filter(item => item && item.order !== null && item.order !== undefined && item.order.toString().trim() !== '')
      .map(item => {
        const key = this.getDraftItemKey(item);
        const existingItem = key ? currentItemsByKey[key] : null;

        if (existingItem) {
          return {
            ...existingItem,
            order: item.order.toString(),
            quantity: parseFloat(item.order)
          };
        }

        return {
          ...item,
          order: item.order.toString(),
          quantity: parseFloat(item.order),
          HeaderId: draftHeaderId,
          headerId: draftHeaderId,
          pack: item.pack || item.packSize,
          packSize: item.packSize || item.pack,
          lineNote: item.lineNote || ''
        };
      });

    const filteredShoppingCartItems = this.getFilteredShoppingCartItems(updatedItems, this.state.filterText);

    this.setState({
      shoppingCartItems: updatedItems,
      filteredShoppingCartItems,
      hasUnsavedChanges: true,
      showAddRemoveItemsModal: false
    });
  };

  handleApproveAndSubmit = () => {
    if (!this.canSubmitOrder()) {
      return;
    }

    this.setState({ showApproveSubmitConfirmation: true });
  };

  confirmApproveAndSubmit = () => {
    this.setState({ showApproveSubmitConfirmation: false });
    this.updatePurchaseOrder(true);
  };

  cancelApproveAndSubmit = () => {
    this.setState({ showApproveSubmitConfirmation: false });
  };

  handleCancelOrder = () => {
    this.setState({ showCancelOrderConfirmation: true });
  };

  confirmCancelOrder = () => {
    this.setState({ showCancelOrderConfirmation: false });
    this.cancelOrder();
  };

  cancelCancelOrder = () => {
    this.setState({ showCancelOrderConfirmation: false });
  };

  handleSaveDraft = () => {
    if (!this.canSubmitOrder()) {
      return;
    }

    this.updatePurchaseOrder(false);
  };

  getUpdatedPurchaseOrderDetails = () => {
    return this.state.shoppingCartItems.map(item => ({
      ...item,
      unit: item.unit,
      price: item.price,
      packSize: item.packSize,
      lineNote: item.lineNote,
      vendorId: item.vendorId,
      itemNumber: item.itemNumber,
      description: item.description,
      quantity: parseFloat(item.order),
      masterRecordId: item.masterRecordId,
      maxPurchaseQuantity: item.maxPurchaseQuantity,
      maxPurchaseQuantityStartDate: item.maxPurchaseQuantityStartDate,
      maxPurchaseQuantityEndDate: item.maxPurchaseQuantityEndDate
    }));
  };

  applyUpdatePurchaseOrderDefaults = (purchaseOrder, submitOrder) => {
    const isMinDateValue = (value) => {
      if (!value) {
        return false;
      }

      if (value instanceof Date) {
        return value.getFullYear() <= 1;
      }

      const textValue = value.toString();
      return textValue.startsWith('0001-01-01') || textValue.startsWith('1/1/0001');
    };

    const normalizeDateFields = (obj) => {
      if (!obj) {
        return;
      }

      Object.keys(obj).forEach((key) => {
        const lowerKey = key.toLowerCase();
        if (lowerKey.includes('date') && isMinDateValue(obj[key])) {
          obj[key] = null;
        }
      });
    };

    const currentDate = moment().toISOString();
    const currentUserName = this.getCurrentUserName();
    const existingInfo = purchaseOrder.purchaseOrderOnlineOrderInfo || {};

    purchaseOrder.purchaseOrderOnlineOrderInfo = {
      ...existingInfo,
      IsSubmitted: submitOrder,
      SubmitDate: submitOrder ? currentDate : (existingInfo.SubmitDate || null),
      ModifiedBy: currentUserName,
      ModifiedDate: currentDate,
      SelectedDeliveryDate: purchaseOrder.purchaseOrderHeader.deliveryDate
    };

    normalizeDateFields(purchaseOrder.purchaseOrderHeader);
    normalizeDateFields(purchaseOrder.purchaseOrderOnlineOrderInfo);
    if (purchaseOrder.purchaseOrderDetails && purchaseOrder.purchaseOrderDetails.length > 0) {
      purchaseOrder.purchaseOrderDetails.forEach(detail => normalizeDateFields(detail));
    }

    purchaseOrder.purchaseOrderHeader.IsApproved = submitOrder;
  };

  updatePurchaseOrder = (submitOrder) => {
    if (this.handleModalDisplay()) {
      return;
    }

    const { purchaseOrder } = this.props;
    const purchaseOrderRoot = _.cloneDeep(purchaseOrder && Object.keys(purchaseOrder).length > 0 ? purchaseOrder : {});
    const baselineHeader = purchaseOrderRoot.PurchaseOrderHeader || purchaseOrderRoot.purchaseOrderHeader || this.state.draftOrder?.purchaseOrderHeader || {};
    const baselineOnlineOrderInfo = purchaseOrderRoot.PurchaseOrderOnlineOrderInfo || purchaseOrderRoot.purchaseOrderOnlineOrderInfo || {};
    const selectedGuideName = baselineOnlineOrderInfo.SelectedGuideName || baselineOnlineOrderInfo.selectedGuideName || baselineHeader.GuideName || baselineHeader.guideName || '';

    const updatedPurchaseOrder = {
      ...purchaseOrderRoot,
      purchaseOrderHeader: {
        ...baselineHeader,
        GuideName: selectedGuideName,
        shipDate: this.state.draftOrder?.purchaseOrderHeader?.shipDate || baselineHeader.shipDate || baselineHeader.ShipDate,
        deliveryDate: this.state.draftOrder?.purchaseOrderHeader?.deliveryDate || baselineHeader.deliveryDate || baselineHeader.DeliveryDate,
        orderNote: this.state.orderNote,
        purchaseOrderNumber: this.state.orderNumber
      },
      purchaseOrderDetails: this.getUpdatedPurchaseOrderDetails()
    };

    this.applyUpdatePurchaseOrderDefaults(updatedPurchaseOrder, submitOrder);

    this.setState({
      orderWasSavedAsDraft: !submitOrder,
      hasUnsavedChanges: false,
      confirmationActionType: submitOrder ? 'approve-submit' : 'save-draft'
    });

    this.props.previewOrderActions.updatePurchaseOrder(updatedPurchaseOrder);
  };

  cancelOrder = () => {
    const isMinDateValue = (value) => {
      if (!value) { return false; }
      if (value instanceof Date) { return value.getFullYear() <= 1; }
      const textValue = value.toString();
      return textValue.startsWith('0001-01-01') || textValue.startsWith('1/1/0001');
    };

    const normalizeDateFields = (obj) => {
      if (!obj) { return; }
      Object.keys(obj).forEach((key) => {
        if (key.toLowerCase().includes('date') && isMinDateValue(obj[key])) {
          obj[key] = null;
        }
      });
    };

    const { purchaseOrder } = this.props;
    const purchaseOrderRoot = _.cloneDeep(purchaseOrder && Object.keys(purchaseOrder).length > 0 ? purchaseOrder : {});
    const baselineHeader = purchaseOrderRoot.PurchaseOrderHeader || purchaseOrderRoot.purchaseOrderHeader || {};
    const baselineOnlineOrderInfo = purchaseOrderRoot.PurchaseOrderOnlineOrderInfo || purchaseOrderRoot.purchaseOrderOnlineOrderInfo || {};
    const currentDate = moment().toISOString();
    const currentUserName = this.getCurrentUserName();

    purchaseOrderRoot.purchaseOrderHeader = {
      ...baselineHeader,
      IsVoid: true,
      orderNote: this.state.orderNote,
      purchaseOrderNumber: this.state.orderNumber
    };

    purchaseOrderRoot.purchaseOrderOnlineOrderInfo = {
      ...baselineOnlineOrderInfo,
      IsSubmitted: false,
      IsCancelled: true,
      CancelledDate: currentDate,
      ModifiedBy: currentUserName,
      ModifiedDate: currentDate
    };

    normalizeDateFields(purchaseOrderRoot.purchaseOrderHeader);
    normalizeDateFields(purchaseOrderRoot.purchaseOrderOnlineOrderInfo);
    if (purchaseOrderRoot.purchaseOrderDetails && purchaseOrderRoot.purchaseOrderDetails.length > 0) {
      purchaseOrderRoot.purchaseOrderDetails.forEach(detail => normalizeDateFields(detail));
    }

    this.setState({
      hasUnsavedChanges: false,
      orderWasSavedAsDraft: false,
      confirmationActionType: 'cancel-order'
    });

    this.props.previewOrderActions.updatePurchaseOrder(purchaseOrderRoot);
  };

  submitPurchaseOrder = () => {
    this.createPurchaseOrder(false);
  };

  getCurrentUserName = () => {
    const { account } = this.props;

    if (!account) {
      return '';
    }

    return account.name || account.accountName || account.username || '';
  };

  createPurchaseOrder = (submitOrder) => {
    if (this.handleModalDisplay()) {
      return;
    }

    const { draftOrder } = this.state;
    const purchaseOrder = {
      purchaseOrderHeader: {
        ...draftOrder.purchaseOrderHeader,
        orderNote: this.state.orderNote,
        purchaseOrderNumber: this.state.orderNumber
      },
      purchaseOrderDetails: this.state.filteredShoppingCartItems.map(item => ({
        unit: item.unit,
        price: item.price,
        packSize: item.packSize,
        lineNote: item.lineNote,
        vendorId: item.vendorId,
        itemNumber: item.itemNumber,
        description: item.description,
        quantity: parseFloat(item.order),
        masterRecordId: item.masterRecordId,
        maxPurchaseQuantity: item.maxPurchaseQuantity,
        maxPurchaseQuantityStartDate: item.maxPurchaseQuantityStartDate,
        maxPurchaseQuantityEndDate: item.maxPurchaseQuantityEndDate
      }))
    };

    if (!submitOrder) {
      helper.applyDraftPurchaseOrderDefaults(purchaseOrder, this.getCurrentUserName());
    }

    this.setState({ canDelete: false, orderWasSavedAsDraft: !submitOrder, hasUnsavedChanges: false });
    this.props.previewOrderActions.createPurchaseOrder(purchaseOrder);
  };

  saveDraftOrder = () => {
    this.createPurchaseOrder(true);
  };

  handleModalDisplay = (item, shouldDeleteItems) => {
    let modalMessage = '';
    let messageType = '';
    let modalErrorType = '';
    let shouldHaltSubmit = false;
    let incomingItem = (item) ? item : null;
    let incomingShouldDeleteItems = (shouldDeleteItems) ? shouldDeleteItems : false;

    if (incomingShouldDeleteItems) {
      modalMessage = `Are you sure you want to remove this item?`;
      messageType = MessageType.WARNING;
      modalErrorType = ModalTypes.RemoveItem;
      shouldHaltSubmit = false;
      this.setState({
        isModalVisible: true,
        itemToRemove: incomingItem,
        modalMessage: modalMessage,
        messageType: messageType,
        modalErrorType: modalErrorType
      });
    }

    return shouldHaltSubmit;
  };

  backToDraftOrders = () => {
    if (this.state.hasUnsavedChanges) {
      this.setState({
        showUnsavedChangesWarning: true,
        unsavedChangesNavigateTo: '/Draft-Orders'
      });
    } else {
      this.props.history.push('/Draft-Orders');
    }
  };

  confirmNavigation = () => {
    this.setState({
      showUnsavedChangesWarning: false,
      hasUnsavedChanges: false
    });
    this.props.history.push(this.state.unsavedChangesNavigateTo);
  };

  cancelNavigation = () => {
    this.setState({
      showUnsavedChangesWarning: false
    });
  };

  ClearTextField = (e) => {
    if (e.currentTarget.onclick) {
      this.setState({
        filterText: '',
        filteredShoppingCartItems: this.state.shoppingCartItems
      });
    }
  };

  buildModal = (message, messageType, modalErrorType, param1, param2) => {
    if (modalErrorType === ModalTypes.RemoveItem) {
      return (
        <PromptModal
          show
          title="ProcureWare Order Management"
          message={message}
          messageType={messageType}
          yesButtonHandler={this.confirmDelete}
          noButtonHandler={this.toggleModal} />
      );
    }

    return (
      <PromptModal
        show
        title="ProcureWare Order Management"
        message={message}
        messageType={messageType}
        okButtonHandler={this.toggleModal} />
    );
  };

  canSubmitOrder = () => {
    const { filteredShoppingCartItems, shoppingCartItems } = this.state;
    const itemsToValidate = shoppingCartItems && shoppingCartItems.length > 0
      ? shoppingCartItems
      : filteredShoppingCartItems;
    const hasBlankQuantity = itemsToValidate && itemsToValidate.some(x => {
      if (!x) {
        return true;
      }

      if (x.order === null || x.order === undefined) {
        return true;
      }

      return x.order.toString().trim() === '';
    });

    let canSubmit = itemsToValidate && itemsToValidate.length > 0 ? true : false;
    canSubmit = canSubmit && itemsToValidate && !itemsToValidate.some(x => x && x.maxPurchaseQuantity > 0 && x.order > x.remainingOrderQuantity);
    canSubmit = canSubmit && !hasBlankQuantity;
    return canSubmit;
  };

  render() {
    const { vendor, account } = this.props;
    const { filteredShoppingCartItems, canShowOrderConfirmation, deletedItems, filterText, isModalVisible, modalMessage, messageType, modalErrorType, showUnsavedChangesWarning, showApproveSubmitConfirmation, showCancelOrderConfirmation, showAddRemoveItemsModal } = this.state;
    const cssClasses = 'fa fa-2x vertical-align-middle';

    if (!account || !account.accountId) {
      return (<Redirect to="/" />);
    }

    if (!this.state.selectedHeaderId) {
      return (<Redirect to="/Draft-Orders" />);
    }

    const orderTotal = helper.getOrderTotal(filteredShoppingCartItems);
    const isSubmitButtonDisabled = !this.canSubmitOrder();
    const canDelete = {
      canDeleteItems: this.state.canDelete,
      disableInputFields: canShowOrderConfirmation
    };

    return (
      <div className="container-fluid pad-bottom-20">
        <ActionBar>
          <ClearableSearchBar
            filterText={filterText}
            multiFilter={this.filter}
            ClearTextField={this.ClearTextField} />

          {!canShowOrderConfirmation &&
            <a id="backToDraftOrders" role="button" onClick={this.backToDraftOrders}>
              <span className="fa fa-undo fa-2x vertical-align-middle" />
              <span className=" pad-left-5">Back to Draft Orders</span>
            </a>
          }

          {!canShowOrderConfirmation &&
            <ActionButton id="btnAddRemoveItems"
              text="Add/Remove Items"
              className={`fa-list-ul ${cssClasses}`}
              clickHandler={this.openAddRemoveItemsModal} />
          }

          {canShowOrderConfirmation &&
            <a id="doneEditing" role="button" onClick={() => this.props.history.push({ pathname: "/Draft-Orders", state: { deletedItems: filteredShoppingCartItems } })}>
              <span className="fa fa-undo fa-2x vertical-align-middle" />
              <span className=" pad-left-5">Back to Draft Orders</span>
            </a>
          }
        </ActionBar>

        {/* Order Details & Order Summary */}
        <div className="col-sm-12 pad-left-0 min-width-950 height_100percent">
          <div className="col-sm-9 pad-left-0 pad-right-0 height_100percent">
            <Table id="tblShoppingCartItems"
              headers={headers}
              items={filteredShoppingCartItems}
              RowComponent={EditDraftOrderRow}
              deleteItem={this.deleteItem}
              itemOptions={canDelete}
              updateLineNote={this.updateLineNote}
              updateQuantity={this.updateQuantity}
              TotalRow={EditDraftOrderTotalRow}
              wrapperClassName="tableWrapper"
              tableClassName="fixed_header"
              filterTypes={[MessageLocation.HeaderBanner]} />
          </div>

          <div className="col-sm-3 height_100percent">
            {!canShowOrderConfirmation &&
              <EditDraftOrderSummary vendor={vendor}
                account={account}
                orderTotal={orderTotal}
                orderSummaryTitlePrefix={this.state.draftOrder?.headerId}
                orderNumber={this.state.orderNumber}
                orderNote={this.state.orderNote}
                shipDate={this.state.draftOrder?.purchaseOrderHeader?.shipDate}
                deliveryDate={this.state.draftOrder?.purchaseOrderHeader?.deliveryDate}
                deliveryDateChangeHandler={this.onDeliveryDateChange}
                shipDateVisible={false}
                deliveryDateVisible
                isSubmitButtonDisabled={isSubmitButtonDisabled}
                submitButtonHandler={this.handleApproveAndSubmit}
                saveDraftButtonHandler={this.handleSaveDraft}
                cancelOrderButtonHandler={this.handleCancelOrder}
                inputChangeHandler={this.onOrderSummaryChange} />
            }

            {canShowOrderConfirmation &&
              <EditDraftOrderConfirmation headerId={this.state.draftOrder?.headerId}
                deliveryDate={this.state.draftOrder?.purchaseOrderHeader?.deliveryDate}
                shipDate={this.state.draftOrder?.purchaseOrderHeader?.shipDate}
                deliveryDateVisible
                shipDateVisible={false}
                actionType={this.state.confirmationActionType}
                printButtonHandler={null} />
            }
          </div>
        </div>

        {/* Prompt Modal */}
        {isModalVisible ?
          this.buildModal(modalMessage, messageType, modalErrorType, filteredShoppingCartItems)
          :
          null}

        {/* Approve and Submit Confirmation Modal */}
        {showApproveSubmitConfirmation &&
          <PromptModal
            show={showApproveSubmitConfirmation}
            title="Approve and Submit Draft Order"
            message="Are you sure you want to Approve and Submit the Order? No additional changes can be made."
            messageType={MessageType.WARNING}
            yesButtonHandler={this.confirmApproveAndSubmit}
            noButtonHandler={this.cancelApproveAndSubmit} />
        }

        {/* Cancel Order Confirmation Modal */}
        {showCancelOrderConfirmation &&
          <PromptModal
            show={showCancelOrderConfirmation}
            title="Cancel Draft Order"
            message="Are you sure you want to cancel this order?"
            messageType={MessageType.WARNING}
            yesButtonHandler={this.confirmCancelOrder}
            noButtonHandler={this.cancelCancelOrder} />
        }

        {/* Unsaved Changes Warning Modal */}
        {showUnsavedChangesWarning &&
          <PromptModal
            show={showUnsavedChangesWarning}
            title="Unsaved Changes"
            message="You have unsaved changes. Are you sure you want to leave?"
            messageType={MessageType.WARNING}
            yesButtonHandler={this.confirmNavigation}
            noButtonHandler={this.cancelNavigation} />
        }

        {showAddRemoveItemsModal
          ? <Modal>
            <AddRemoveItemsModal
              show
              selectedOrderGuide={this.props.selectedOrderGuide}
              orderGuideItems={this.props.orderGuideItems}
              currentDraftItems={this.state.shoppingCartItems}
              closeButtonHandler={this.closeAddRemoveItemsModal}
              previewButtonHandler={this.syncItemsFromOrderGuidePreview} />
          </Modal>
          : null
        }
      </div>
    );
  }
}

export const mapStateToProps = state => {
  return {
    vendor: selectors.getVendor(state),
    account: selectors.getAccount(state),
    headerId: selectors.getHeaderId(state),
    shoppingCartItems: selectors.getSortedShoppingCart(state),
    orderGuideItems: selectors.getSortedOrderGuide(state),
    orderDetailPdf: selectors.getOrderDetailPdf(state),
    purchaseOrder: state && state.purchaseOrder ? state.purchaseOrder.fetchedPurchaseOrder : {},
    purchaseOrderUpdateResult: state && state.purchaseOrder ? state.purchaseOrder.updateResult : null,
    selectedOrderGuide: selectors.getSelectedOrderGuide(state),
    selectedShipDate: selectors.getSelectedShipDate(state),
    selectedDeliveryDate: selectors.getSelectedDeliveryDate(state),
    conceptAttributes: selectors.getConceptAttributes(state)
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    documentActions: bindActionCreators(documentActions, dispatch),
    previewOrderActions: bindActionCreators(previewOrderActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDraftOrder);
